export default "__VITE_ASSET__DTNbQBmB__"